/**
 * Checks whether or not a user has meetings after the specified date.
 *
 * Returns a promise that resolves to the level at which the user has post-date meetings:
 * 'ORGANIZER', 'ACCOUNT', or 'NONE' if there are no post-date meetings
 */
define('lib/models/account/check-meetings-after-date',['require','jquery','moment','api-access'],function (require) {
    var $ = require('jquery');
    var moment = require('moment');
    var meetingsApi = require('api-access').meetings;

    var NONE = 'NONE';
    var ORGANIZER = 'ORGANIZER';
    var ACCOUNT = 'ACCOUNT';

    return function (dateResponse, isBillingAdmin, seats) {
        var checking = $.Deferred();
        var date = moment(dateResponse);

        meetingsApi.forOrganizer({includeMeetingsICoorganize: true}).then(function (meetings) {
            var meetingsAfterDate = meetings.filter(function (meeting) {
                var startTime = moment(meeting.scheduledStartTime);
                return startTime > date || meeting.meetingType === 'recurring';
            });

            if (meetingsAfterDate.length) {
                checking.resolve(ORGANIZER);
            } else if (isBillingAdmin && seats > 1) {
                meetingsApi
                    .forAccount({from: date.valueOf()})
                    .then(function (accountMeetingsAfterEnd) {
                        if (accountMeetingsAfterEnd.total) {
                            checking.resolve(ACCOUNT);
                        } else {
                            checking.resolve(NONE);
                        }
                    });
            } else {
                checking.resolve(NONE);
            }
        });

        return checking.promise();
    };
});

